import { AxiosError, ErrorField } from '../types';

export const parseRegistrationError = (
    error: unknown,
    fallbackMessage: string,
): string | ErrorField[] => {
    try {
        const response = (error as AxiosError)?.response?.data;

        if (!response?.data || typeof response.data === 'string') {
            return fallbackMessage;
        }

        const dataArray = response.data as ErrorField[];

        const nestedErrors = dataArray.flatMap((item) => item.nested_errors?.[0] || []);

        if (
            nestedErrors.length === 1 &&
            (nestedErrors[0].field === 'inn' || nestedErrors[0].field === 'ogrn_or_inn')
        ) {
            return nestedErrors[0].description || fallbackMessage;
        }

        return nestedErrors.length > 0 ? nestedErrors : fallbackMessage;
    } catch {
        return fallbackMessage;
    }
};

export const parseApprovalError = (error: unknown, fallbackMessage: string): string => {
    try {
        const response = (error as AxiosError)?.response?.data;

        if (response?.data && typeof response.data === 'string') {
            return response.data;
        }

        if (response?.content) {
            return response.content;
        }
    } catch {
        return fallbackMessage;
    }

    return fallbackMessage;
};

export const parseFieldError = (
    error: unknown,
    fieldName: string,
    fallbackMessage: string,
): string => {
    try {
        const response = (error as AxiosError)?.response?.data;

        if (!response?.data || typeof response.data === 'string') {
            return fallbackMessage;
        }

        const dataArray = response.data as ErrorField[];
        const fieldError = dataArray.find((item) => item.field === fieldName);

        if (fieldError?.description) {
            return fieldError.description;
        }
    } catch {
        return fallbackMessage;
    }

    return fallbackMessage;
};

export const parseGenericError = (error: unknown, fallbackMessage: string): string => {
    try {
        const response = (error as AxiosError)?.response?.data;

        if (!response?.data) {
            return fallbackMessage;
        }

        if (typeof response.data === 'string') {
            return response.data;
        }

        const dataArray = response.data as ErrorField[];
        if (dataArray.length > 0 && dataArray[0].description) {
            return dataArray[0].description;
        }
    } catch {
        return fallbackMessage;
    }

    return fallbackMessage;
};
